import { Routes, Route } from "react-router-dom";
import InfoView from "./InfoView";

const InvitationsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<InfoView />} />
    </Routes>
  );
};

export default InvitationsRouter;
